
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userPreferences"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"result"},"name":{"kind":"Name","value":"userPreferences"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"languageCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"languageDirection"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"utcOffsetSecs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"initialCoordinates"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lng"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"initialZoomLevel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"trackerLiveTripStrokeColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showLiveTraffic"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showMapPointsOfInterest"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"defaultMapDisplay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"followTracker"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayLandmarksInLiveView"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayGeofencesInLiveView"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customReportsLogo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contactName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contactMobile"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is2FAEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ipWhitelist"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vehicleTypeIcons"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vehicleTypeID"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"iconID"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":655}};
    doc.loc.source = {"body":"query userPreferences {\n    result: userPreferences {\n        country\n        languageCode\n        languageDirection\n        utcOffsetSecs\n        initialCoordinates {\n            lat\n            lng\n        }\n        initialZoomLevel\n        trackerLiveTripStrokeColor\n        showLiveTraffic\n        showMapPointsOfInterest\n        defaultMapDisplay\n        followTracker\n        displayLandmarksInLiveView\n        displayGeofencesInLiveView\n        logo\n        customReportsLogo\n        contactName\n        contactMobile\n        is2FAEnabled\n        ipWhitelist\n        vehicleTypeIcons {\n            vehicleTypeID\n            iconID\n        }\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["userPreferences"] = oneQuery(doc, "userPreferences");
        
